//* Libraries imports
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

//* Components imports
import { FormWizardPage as CompleteFormPage } from "./FormWizardPage";
import FirstFormPage from "@/features/FirstFormPage/FirstFormPage";

//* Types imports
import {
  PhaseFormFieldType,
  PhaseFormFormat,
} from "@/features/phaseForm/types";

//* Service imports
import { phaseFormService } from "@/features/phaseForm/phaseFormService";

export const FormRouter: React.FC = () => {
  const { id, processId, productId, clientId } = useParams();
  const [format, setFormat] = useState<PhaseFormFormat | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFormDisplay = async () => {
      try {
        console.log("Params recebidos:", {
          id,
          processId,
          productId,
          clientId,
        });
        const response = await phaseFormService.getById(id!, clientId);
        console.log("resposta", response, processId);
        let has_binding = false;
        response.data?.formFields?.map((item) => {
          if (
            item.type == PhaseFormFieldType.BINDING_QUESTION &&
            processId != "new"
          ) {
            has_binding = true;
          }
        });
        const formatValue =
          has_binding == false
            ? (response.data?.format as PhaseFormFormat) || PhaseFormFormat.LONG
            : PhaseFormFormat.SHORT;
        setFormat(formatValue);
      } catch (err) {
        setError("Erro ao carregar o formulário");
        console.error("Erro ao buscar tipo de formulário:", err);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchFormDisplay();
    }
  }, [id, processId, productId, clientId]);

  if (loading) {
    return <div>Carregando...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (format === PhaseFormFormat.SHORT) {
    return <FirstFormPage clientId={clientId} />;
  }

  return <CompleteFormPage clientId={clientId} />;
};
